import React from 'react'
import PropTypes from 'prop-types'
import CategoryList from '~/components/common/Categories'

const FieldCategoryList = ({
  allCategories,
  field,
  form,
  disabled,
  ...props
}) => (
  <CategoryList
    allCategories={allCategories}
    {...field}
    onCheck={(id, status) => {
      const checkCategory = allCategories.find((c) => c.id === id)
      let sltCategories = [...form.getFieldProps(field.name).value]
      if (status) {
        sltCategories.push(checkCategory)
      } else {
        sltCategories = sltCategories.filter((c) => c.id !== id)
      }
      form.setFieldValue(
        field.name,
        sltCategories.map((c) => ({ id: c.id, name: c.name, slug: c.slug })),
      )
    }}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)
FieldCategoryList.defaultProps = {
  allCategories: [],
  disabled: false,
}

FieldCategoryList.propTypes = {
  allCategories: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape())]),
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
}

export default FieldCategoryList
